import {VACATIONS_ABSENCES_URLS} from './endpoints.constants';

const API_URL = process.env.API_URL;
const EMPLOYEE_URL = `${API_URL}/${VACATIONS_ABSENCES_URLS.EMPLOYEE_ROOT}`;
const MANAGER_URL = `${API_URL}/${VACATIONS_ABSENCES_URLS.MANAGER_ROOT}`;

const ENDPOINTS_EMPLOYEE = {
  get: {
    initial: (employeeId, year) => `${EMPLOYEE_URL}/${employeeId}/initial/${year}`,
    relapses: (employeeId) => `${EMPLOYEE_URL}/${employeeId}/relapses`,
    vacationScheduleEndDate: `${EMPLOYEE_URL}/vacation-schedule-end-date`,
    schedule: (employeeId) => `${EMPLOYEE_URL}/${employeeId}/schedule`
  },
  post: {
    request: (employeeId) => `${EMPLOYEE_URL}/${employeeId}/holidays`,
    medicalParts: (employeeId) => `${EMPLOYEE_URL}/${employeeId}/holidays/medical-parts`
  },
  put: {
    request: (employeeId) => `${EMPLOYEE_URL}/${employeeId}/holidays`,
    discharge: (employeeId) => `${EMPLOYEE_URL}/${employeeId}/holidays/discharge`
  },
  delete: {
    request: (employeeId) => `${EMPLOYEE_URL}/${employeeId}/holidays`
  }
};

const ENDPOINTS_MANAGER = {
  get: {
    initial: (managerId, year) => `${MANAGER_URL}/${managerId}/initial/${year}`,
    initialEmployee: (userId, userInceptionId, year) => {
      let employeeId = userInceptionId;
      let managerId = userId;
      return `${MANAGER_URL}/inception/${managerId}/initial/${employeeId}/${year}`;
    },
    coincidences: (managerId) => `${MANAGER_URL}/${managerId}/coincidences`,
    requests: (managerId) => `${MANAGER_URL}/${managerId}/requests`,
    relapses: (employeeId, managerId) => `${MANAGER_URL}/inception/${managerId}/relapses/${employeeId}`,
    schedule: (employeeId, managerId) => `${MANAGER_URL}/inception/${managerId}/schedule/${employeeId}`
  },
  post: {
    request: (employeeId, managerId) => `${MANAGER_URL}/inception/${managerId}/requests/${employeeId}`,
    medicalParts: (employeeId, managerId) => `${MANAGER_URL}/inception/${managerId}/holidays/medical-parts/${employeeId}`
  },
  put: {
    request: (employeeId, managerId) => `${MANAGER_URL}/inception/${managerId}/requests/${employeeId}`,
    requests: (managerId) => `${MANAGER_URL}/${managerId}/requests`,
    discardRequest: (managerId) => `${MANAGER_URL}/${managerId}/requests/discard`,
    discharge: (employeeId, managerId) => `${MANAGER_URL}/inception/${managerId}/holidays/discharge/${employeeId}`
  },
  delete: {
    request: (employeeId, managerId) => `${MANAGER_URL}/inception/${managerId}/requests/${employeeId}`
  }
};

export {
  ENDPOINTS_EMPLOYEE,
  ENDPOINTS_MANAGER
};



// WEBPACK FOOTER //
// ./client/app/common/endpoints/vacations-absences.endpoints.js